export default "__VITE_ASSET__C9m0aAgy__"